import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageCircle, FileText, Clock, HelpCircle } from "lucide-react";

export function ExpertCallsSection() {
  const navigate = useNavigate();

  const topics = [
    { icon: FileText, title: "Fair Deal Scheme", description: "Understand eligibility, costs, and how to apply" },
    { icon: Clock, title: "Finding the Right Home", description: "What to look for and questions to ask" },
    { icon: HelpCircle, title: "Care Assessments", description: "How needs are assessed and what to expect" },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-grandpal-green/10 mb-5">
            <MessageCircle className="h-7 w-7 text-grandpal-green" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Free Care Advisor
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Not sure where to start? Chat with our Care Advisor for instant, 
            free guidance on nursing homes, the Fair Deal scheme, and your next steps.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-10">
          {topics.map((topic, index) => (
            <button
              key={index}
              onClick={() => navigate('/consultations')}
              className="text-center p-6 rounded-xl border border-border bg-card hover:shadow-md hover:border-grandpal-green/30 transition-all cursor-pointer"
            >
              <topic.icon className="h-8 w-8 text-grandpal-green mx-auto mb-3" />
              <h3 className="font-semibold text-foreground mb-2">{topic.title}</h3>
              <p className="text-sm text-muted-foreground">{topic.description}</p>
            </button>
          ))}
        </div>

        <div className="text-center">
          <Button
            size="lg"
            className="bg-grandpal-green hover:bg-grandpal-green/90 text-white px-8"
            onClick={() => navigate('/consultations')}
          >
            <MessageCircle className="h-5 w-5 mr-2" />
            Chat with Care Advisor
          </Button>
          <p className="text-sm text-muted-foreground mt-3">Free · No sign-up required · Instant answers</p>
        </div>
      </div>
    </section>
  );
}